import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { StandardPolicyGuard } from 'src/auth/guard';
// layouts
import AppLayout from 'src/layouts/app';
// components
import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

const SetupPage = lazy(() => import('src/pages/setup/setup'));

// ----------------------------------------------------------------------

export const setupRoutes = [
  {
    path: 'setup',
    element: (
      <StandardPolicyGuard
        fallback={
          <AppLayout>
            <LoadingScreen />
          </AppLayout>
        }
      >
        <AppLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </AppLayout>
      </StandardPolicyGuard>
    ),
    children: [{ element: <SetupPage />, index: true }],
  },
];
